import { Header } from "./header";
import { Navigation } from "./navigation";
import { DomHelper } from "../general/utils";


export default class WindowEvents {
    constructor () {
        let _scope = this;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.updateOnPageScroll = this.updateOnPageScroll.bind(this);

        window.onload = function (event) {
            _scope.load(event);
        };
    }

    load () {
        let e = DomHelper.isTouchDevice() ? 'orientationchange' : 'resize';

        Header.init();
        Navigation.init();

        window.addEventListener('scroll', this.onScroll, false);

        window.addEventListener(e, function () {
            setTimeout(function () {
                Navigation.onResize();
            }, 100);
        });

        // lazy init videojs only on pages that actually have videos
        const videos = document.getElementsByClassName('video-wrapper');

        if(videos.length){
            import("../contentelements/video").then(({default: VideoJs})=>{
                for(let video of videos) {
                    VideoJs.initVideoJs(video)
                }
                window.addEventListener('scroll', ()=>{
                    for(let video of videos) {
                        VideoJs.initVideoJs(video)
                    }
                }, {passive: true})
            })
        }

    }

    onScroll() {
        if(!this.ticking) {
            window.requestAnimFrame(this.updateOnPageScroll);
            this.ticking = true;
        }
    }

    updateOnPageScroll() {
        Header.setStickyHeaderView();
        this.ticking = false;
    }
}